import "./App.css";
import "../src/styles.css";

import { Box } from "@mui/material";
import Header from "../src/components/Header";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import ResultPageCarousel from "./page/ResultPageCarousel";
import HomePage from "./page/HomePage";
import HomePageCV from "./page/HomePageCV"; // Import HomePageCV
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProtectedRoute from "./components/common/ProtectedRoute";
import AuthProvider from "../src/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { getEmail } from "../src/utils/storage";
import { fetchAppConfiguration } from "./redux/thunk/fetchAppConfiguration";
import Login from "../src/page/Login";
import UploadResume from "./components/ResumeUpload";
import ContactUs from "./page/ContactUs";
import ResumePublicProfile from "./page/ResumePublicProfile";
import ResumeHistory from "./page/ResumeHistory";
import ResumeUploadRecruiter from "./components/ResumeUploadRecruiter";
import RecruiterResumeHistory from "./page/RecruiterResumeHistory";
import RecruiterResumeProfile from "./page/RecruiterResumeProfile";
import AdvancedDataSearch from "./page/AdvancedDataSearch";
import ResumeRanker from "./page/ResumeRanker";
import JdwithDataSearch from "./page/JdwithDataSearch"; // Import the new page
import PendingResumes from "./page/PendingResumes";
import AllElements from "./page/AllElements";
import NetworkWatcher from "./components/common/NetworkWatcher";
import NetworkError from "./components/common/NetworkError";
import { useEffect, useState } from "react";

function App() {
  const IncognitoModeStatus = useSelector(
    (state) => state.IncognitoMode?.IncognitoUser || false
  );
  // const isLoggedIn = sessionStorage.getItem("isLoggedIn");
  const New_Result_Show = useFeatureFlag("New_Result_Show");
  const New_Theme = useFeatureFlag("New_Theme");
  const Environment = process.env.REACT_APP_ENV;
  const theme = createTheme({
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#26801E",
        border: New_Theme
          ? IncognitoModeStatus
            ? "#fff"
            : "#FDF9E0"
          : "#26801E",
        evalute: "#2BB344",
        evalutebackground: "#EEFFF1",
        incognitoBackground: "#999999",
        incognitoText: "#fff",
        nestedQuestionBackground: New_Theme
          ? IncognitoModeStatus
            ? "#ebebeb"
            : "#edfff1"
          : "#edfff1",
        nestedQuestionBorder: "1px solid #fff",

        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: "#0066ff",
        main: "#0044ff",
        // dark: will be calculated from palette.secondary.main,
        contrastText: "#ffcc00",
      },
      error: {
        // light: "#0066ff",
        main: "#EF4F38",
        // dark: will be calculated from palette.secondary.main,
        // contrastText: "#ffcc00",
      },
      text: {
        primary: "#000",
        pricing: "#000",
      },
      // Provide every color token (light, main, dark, and contrastText) when using
      // custom colors for props in Material UI's components.
      // Then you will be able to use it like this: `<Button color="custom">`
      // (For TypeScript, you need to add module augmentation for the `custom` value)
      custom: {
        light: "#ffa726",
        main: "#f57c00",
        dark: "#ef6c00",
        contrastText: "rgba(0, 0, 0, 0.87)",
      },

      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: `"Inter", sans-serif`,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontSize: "18px",
            // color: "#727272",
            color: "#232323",
            // "& h1,h2": {
            //   color: "black",
            // },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "16px",
            textTransform: "none",
            borderRadius: 28,
            padding: "8px 30px",
            minWidth: "unset",
          },
          contained: {
            // Targeting contained variant
            root: {
              fontSize: "16px",
              textTransform: "none",
              borderRadius: 28,
              padding: "8px 30px",
              minWidth: "unset",
              backgroundColor: New_Theme ? "#0D9B21" : "#26801E",
              color: "#fff",
              "&:hover": {
                backgroundColor: New_Theme ? "#35b848 !important" : "#fff",
              },
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            borderColor: New_Theme ? "#21175E" : "#26801E",
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: New_Theme ? "#21175E" : "#26801E",
              borderWidth: "2px",
              color: "#000",
            },
            backgroundColor: "#fff", // Background color of the Select component
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
            "&.MuiAutocomplete-option": {
              backgroundColor: "#fff", // Background color of the Select component
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          inputRoot: {
            borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired border color
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
          },
          popper: {
            "& .MuiPaper-root": {
              backgroundColor: "#fff", // Background color of the dropdown
            },
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired border color
            "&:focus": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired focus border color
            },
            "&:active": {
              borderColor: New_Theme ? "#21175E" : "#26801E", // Change this to your desired active border color
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            "&.Mui-focused": {
              color: New_Theme ? "#FDF9E0" : "#26801E", // Change this to your desired color for focused label
            },
            color: "#000",
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: New_Theme ? "#21175E" : "#26801E", // Change this to your desired color for radio buttons
          },
        },
      },
    },
    // breakpoints: {
    //   ...customBreakpoints,
    // },
  });
  theme.typography.h1 = {
    fontSize: "3rem",
    lineHeight: "3rem",
    "@media (max-width:600px)": {
      fontSize: "2.2rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "3rem",
    },
  };
  theme.typography.h2 = {
    fontSize: "2.125rem",
    lineHeight: "2.125rem",

    "@media (max-width:600px)": {
      fontSize: "1.625rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "2rem",
    },
  };
  theme.typography.h3 = {
    fontSize: "1.75rem",
    lineHeight: "1.75rem",

    "@media (max-width:600px)": {
      fontSize: "1.375rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.6rem",
    },
  };
  theme.typography.h4 = {
    fontSize: "1.5rem",
    lineHeight: "2rem",

    "@media (max-width:600px)": {
      fontSize: "1.25rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  theme.typography.h5 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  theme.typography.h6 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };
  theme.typography.h6 = {
    fontSize: "1.2rem",
    lineHeight: "1.5rem",

    "@media (max-width:600px)": {
      fontSize: "1rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  };

  const Admin_Access = useFeatureFlag("Admin_Access");
  // Check if Admin_Access is valid JSON or fall back to an empty array
  let allowedEmails = [];
  try {
    if (Admin_Access) {
      allowedEmails = JSON.parse(Admin_Access);
    }
  } catch (error) {
    console.error("Error parsing Admin_Access:", error);
  }
  const userEmail = getEmail();
  const dispatch = useDispatch();
  const secretEncodeDecodeString = useFeatureFlag("secretEncodeDecodeString");
  const staticRandomEncodeDecodeString = useFeatureFlag(
    "staticRandomEncodeDecodeString"
  );
  const isAICVHost = window.location.hostname.includes("aicv.trueselfy.com");

  const isLoggedIn =
    useSelector((state) => state?.userReducer?.isLoggedIn) || false;

  const viewAsRecruiter =
    useSelector((state) => state?.userReducer?.viewAsRecruiter) || false;

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  // Fetch app configuration on app load (only once)
  useEffect(() => {
    dispatch(fetchAppConfiguration());
  }, [dispatch]);

 
  return (
    <>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <NetworkWatcher isOnline={isOnline} />

            <Routes>
              <Route
                path="/network-error"
                element={
                  <ProtectedRoute>
                    <NetworkError />
                  </ProtectedRoute>
                }
              />
              <Route path="/signin" element={<Login />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route
                exact
                path="/"
                element={
                  isAICVHost ? (
                    <ProtectedRoute>
                      <HomePageCV />
                    </ProtectedRoute>
                  ) : (
                    <ProtectedRoute>
                      <HomePage />
                    </ProtectedRoute>
                  )
                }
              />
              <Route exact path="/aicv" element={<HomePageCV />} />
              {/* <Route path="*" element={<Navigate to="/" />} /> */}
              <Route
                exact
                path="/Upload-Resume"
                element={
                  isLoggedIn && !viewAsRecruiter ? (
                    <ProtectedRoute>
                      <UploadResume
                        secretEncodeDecodeString={secretEncodeDecodeString}
                        staticRandomEncodeDecodeString={
                          staticRandomEncodeDecodeString
                        }
                      />
                    </ProtectedRoute>
                  ) : (
                    <ProtectedRoute>
                      <ResumeUploadRecruiter
                        secretEncodeDecodeString={secretEncodeDecodeString}
                        staticRandomEncodeDecodeString={
                          staticRandomEncodeDecodeString
                        }
                      />
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                exact
                path="/public-profile/:id"
                element={
                  isLoggedIn ? (
                    <ProtectedRoute>
                      <ResumePublicProfile />
                    </ProtectedRoute>
                  ) : (
                    <ResumePublicProfile />
                  )
                }
              />
              <Route
                exact
                path="/all-elements/:id"
                element={
                  <ProtectedRoute>
                    <AllElements />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/profile/:id"
                element={
                  <ProtectedRoute>
                    <ResumePublicProfile />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/candidate-profile/:id"
                element={
                  <ProtectedRoute>
                    <RecruiterResumeProfile />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/resume-history"
                element={
                  isLoggedIn && !viewAsRecruiter ? (
                    <ProtectedRoute>
                      <ResumeHistory />
                    </ProtectedRoute>
                  ) : (
                    <ProtectedRoute>
                      <RecruiterResumeHistory />
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                exact
                path="/resume-history/:id"
                element={
                  isLoggedIn && !viewAsRecruiter ? (
                    <ProtectedRoute>
                      <ResumePublicProfile />
                    </ProtectedRoute>
                  ) : (
                    <ProtectedRoute>
                      <RecruiterResumeProfile />
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                exact
                path="/advanced-data-search"
                element={
                  isLoggedIn && viewAsRecruiter ? (
                    <ProtectedRoute>
                      <AdvancedDataSearch />
                    </ProtectedRoute>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/resume-ranker"
                element={
                  isLoggedIn && viewAsRecruiter ? (
                    <ProtectedRoute>
                      <ResumeRanker />
                    </ProtectedRoute>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/advanced-jd-search"
                element={
                  isLoggedIn && viewAsRecruiter ? (
                    <ProtectedRoute>
                      <JdwithDataSearch />
                    </ProtectedRoute>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                exact
                path="/pending-resumes"
                element={
                  isLoggedIn && viewAsRecruiter ? (
                    <ProtectedRoute>
                      <PendingResumes
                        secretEncodeDecodeString={secretEncodeDecodeString}
                        staticRandomEncodeDecodeString={
                          staticRandomEncodeDecodeString
                        }
                      />
                    </ProtectedRoute>
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
      {/* <Box sx={{ display: "grid", placeItems: "center", height: "80vh" }}>
          
        </Box> */}
    </>
  );
}

export default App;
